import AUD from 'assets/svg/Australia.svg';
import CAD from 'assets/svg/Canada.svg';
import CNY from 'assets/svg/China.svg';
import DKK from 'assets/svg/Denmark.svg';
import EURO from 'assets/svg/EuropeanUnion.svg';
import JPY from 'assets/svg/Japan.svg';
import NZD from 'assets/svg/NewZealand.svg';
import NOK from 'assets/svg/Norway.svg';
import PLN from 'assets/svg/Poland.svg';
import SEK from 'assets/svg/Sweden.svg';
import CHF from 'assets/svg/Switzerland.svg';
import AED from 'assets/svg/UnitedArabEmirates.svg';
import GBP from 'assets/svg/UnitedKingdom.svg';
import USD from 'assets/svg/UnitedStates.svg';
import { Currency } from 'types/global.types';

const getCurrencyIconPath = (currency: Currency) => {
  switch (currency?.toUpperCase?.()) {
    case 'EUR':
      return EURO;
    case 'USD':
      return USD;
    case 'AUD':
      return AUD;
    case 'CAD':
      return CAD;
    case 'CHF':
      return CHF;
    case 'CNY':
      return CNY;
    case 'DKK':
      return DKK;
    case 'GBP':
      return GBP;
    case 'JPY':
      return JPY;
    case 'PLN':
      return PLN;
    case 'NOK':
      return NOK;
    case 'SEK':
      return SEK;
    case 'NZD':
      return NZD;
    case 'AED':
      return AED;
    default:
      return null;
  }
};

export default getCurrencyIconPath;
